import { makeAutoObservable } from 'mobx';

export class PostClosingModalStore {
  modalProps = null;

  constructor() {
    makeAutoObservable(this);
  }

  open(props) {
    this.modalProps = props;
  }

  close() {
    this.modalProps = null;
  }
}